import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './card.module.scss';
import { Loader } from '@huggg/react-components';
import HugggImage from 'components/Huggg/HugggImage';
import CardContent from './CardContent';
import CardFooter from './CardFooter';

const CardReveal = ({
  huggg,
  brandAssets,
  redeemedSegmentImage,
  brandName,
  voucherAmount,
  formattedVoucherExpiry,
  processedVoucherLabel,
  isWaitingForFulfil,
  onClaimCard,
  isLoading
}) => {
  if (isLoading) {
    return <Loader className={styles.loader} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <HugggImage
        huggg={huggg}
        imageOverride={brandAssets.logoUrl || redeemedSegmentImage}
        className={classnames(styles.logoImage)}
      />

      <hr className={classnames(styles.divider)} />

      <CardContent
        brandAssets={brandAssets}
        brandName={brandName}
        voucherAmount={voucherAmount}
        formattedVoucherExpiry={formattedVoucherExpiry}
        processedVoucherLabel={processedVoucherLabel}
        isWaitingForFulfil={isWaitingForFulfil}
        onClaimCard={onClaimCard}
      />

      <CardFooter huggg={huggg} />
    </div>
  );
};

CardReveal.propTypes = {
  huggg: PropTypes.object.isRequired,
  brandAssets: PropTypes.object.isRequired,
  redeemedSegmentImage: PropTypes.string,
  brandName: PropTypes.string,
  voucherAmount: PropTypes.string,
  formattedVoucherExpiry: PropTypes.string,
  processedVoucherLabel: PropTypes.string,
  isWaitingForFulfil: PropTypes.bool.isRequired,
  onClaimCard: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default CardReveal;
